<template>
  <div class="agencyItem">
    <div class="contain">
      <div class="bg">
        <img
          :src="item.imageInfoVos && item.imageInfoVos.length > 0
            ? `${urlImg}${item.imageInfoVos[0].imgUrl}`
            : localUrl"
          alt
        />
      </div>
      <div class="content">
        <div class="title">{{item.orgName}}</div>
        <div class="phone">
            <van-icon name="phone" />
            <span>{{ item.phone }}</span>
            <span v-if="hasRightTag">{{ item.orgType }}</span>
        </div>
        <div class="message">
          <van-icon name="location" />
          <span>{{ item.addr }}</span>
        </div>
      </div>
      
    </div>
    <!-- <van-card
        :title="item.orgName+1111111"
        :thumb="
          item.imageInfoVos && item.imageInfoVos.length > 0
            ? `${urlImg}${item.imageInfoVos[0].imgUrl}`
            : localUrl
        "
      >
        <template #tags>
          <div class="phone">
            <div>
              <van-icon name="phone" />
              <span>{{ item.phone }}</span>
            </div>
            <span v-if="hasRightTag">{{ item.orgType }}</span>
          </div>
          <div class="message">
            <van-icon name="location" />
            <span>
              {{ item.addr }}
            </span>
          </div>
        </template>
      </van-card> -->
  </div>
</template>

<script>
export default {
  name: "agencyItem",
  data() {
    return {
      urlImg: process.env.VUE_APP_API_IMGURL,
    };
  },
  props: {
    hasRightTag: {
      default: false,
      type: Boolean,
    },
    item: {
      default: () => {
        return {};
      },
      type: Object,
      required: true,
    },
  },
  methods: {},
  mounted() {
    console.log("1");
  },
  computed: {
    localUrl() {
      switch (this.item["index"]) {
        case 1:
          return require("@/assets/images/机构照片/长者运动健康之家/运动健康之家1.jpg");
        case 2:
          return require("@/assets/images/机构照片/睦邻中心/睦邻中心1.jpg");
        case 3:
          return require("@/assets/images/机构照片/睦邻中心/睦邻分中心1.jpg");
        case 4:
          return require("@/assets/images/机构照片/适老化体验中心/适老化1.jpg");
        case 5:
          return require("@/assets/images/机构照片/养老院/黄浦区南京街道敬老院1.jpeg");
      }
      return "http//:baidu.com";
    },
  },
};
</script>

<style lang="scss" scoped>
.agencyItem {
  height: 145px;
  padding: 10px 20px;
}
// .van-nav-bar {
//   ::v-deep {
//     .van-icon {
//       color: #000;
//       font-size: 20px;
//       font-weight: 700;
//     }

//     .van-nav-bar__text {
//       padding-left: 10px;
//       font-size: 20px;
//       color: #000;
//       font-weight: normal;
//     }
//   }
// }
// .van-card {
//   ::v-deep {
//     .van-card__thumb {
//       margin-top: 8px;
//       height: 100px;
//       width: 80px;
//       margin-right: 20px;
//     }

//     .van-card__title {
//       white-space: inherit;
//       margin-top: 10px;
//       opacity: 1;
//       font-size: 14px;
//       font-family: PingFang SC, PingFang SC-Bold;
//       font-weight: 700;
//       line-height: 16px;
//       color: #222222;
//     }
//   }
//   .phone {
//     margin-top: 10px;
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     .van-icon {
//       color: #4eaefc;
//       font-size: 14px;
//     }
//     span {
//       margin-left: 10px;
//       opacity: 1;
//       font-size: 12px;
//       font-family: PingFang SC, PingFang SC-Bold;
//       font-weight: 700;
//       text-align: left;
//       color: #757a8c;
//       line-height: 24px;
//     }
//     & > span:nth-child(2) {
//       display: inline-block;
//       background-color: #d2eeff;
//       padding: 0 5px;
//       height: 18px;
//       opacity: 1;
//       font-size: 10px;
//       font-family: PingFang SC, PingFang SC-Bold;
//       font-weight: 700;
//       text-align: center;
//       color: #7dceff;
//       line-height: 18px;
//       border-radius: 3px;
//     }
//   }
//   .message {
//     display: flex;
//     .van-icon {
//       color: #4eaefc;
//       font-size: 14px;
//       margin-top: 5px;
//     }

//     span {
//       margin-left: 6px;
//       opacity: 1;
//       font-size: 12px;
//       font-family: PingFang SC, PingFang SC-Bold;
//       font-weight: 700;
//       text-align: left;
//       color: #757a8c;
//       line-height: 24px;
//     }
//   }
// }
.contain {
  // height: 100%;
  border-bottom: 4px solid #e9f6ff;
  background-color: #fafafa;
  display: flex;
  padding: 5px 10px;
  // justify-content: space-between;
  align-items: center;
  .bg{
    margin-top: 8px;
    height: 100px;
    width: 80px;
    margin-right: 20px;
    img{
      width: 80px;
      height: 100px;
      border-radius: 8px;
    }
  }
  .content{
    flex: 1;
    .title{
      margin-top: 10px;
      opacity: 1;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Bold;
      font-weight: 700;
      line-height: 20px;
      padding-bottom: 5px;
      color: #222222;
    }
  }
  .phone {
    // margin-top: 10px;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    .van-icon {
      color: #4eaefc;
      font-size: 14px;
    }
    span {
      flex: 1;
      margin-left: 10px;
      opacity: 1;
      font-size: 12px;
      font-family: PingFang SC, PingFang SC-Bold;
      font-weight: 700;
      text-align: left;
      color: #757a8c;
      line-height: 24px;
    }
    & > span:nth-child(3) {
      display: inline-block;
      background-color: #d2eeff;
      padding: 0 5px;
      height: 18px;
      opacity: 1;
      font-size: 10px;
      font-family: PingFang SC, PingFang SC-Bold;
      font-weight: 700;
      text-align: center;
      color: #7dceff;
      line-height: 18px;
      border-radius: 3px;
    }
  }
  .message {
    display: flex;
    .van-icon {
      color: #4eaefc;
      font-size: 14px;
      margin-top: 5px;
    }

    span {
      margin-left: 6px;
      opacity: 1;
      font-size: 12px;
      font-family: PingFang SC, PingFang SC-Bold;
      font-weight: 700;
      text-align: left;
      color: #757a8c;
      line-height: 24px;
    }
  }
}
</style>
